import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
import { setTemporaryHoursFormSchema } from './set-temporary-hours-form.schema';
import { useEffect } from 'react';

export const useSetTemporaryHoursForm = selectedEvent => {
  const form = useForm({
    resolver: yupResolver(setTemporaryHoursFormSchema),
    defaultValues: setTemporaryHoursFormSchema.cast(selectedEvent ?? {}),
  });

  const { reset } = form;
  useEffect(() => {
    reset(selectedEvent ?? {});
  }, [reset, selectedEvent]);

  return { form };
};
